import { blue } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Dialog } from 'shared/mui/Dialogs';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': { width: '640px', maxWidth: '640px' },
});

export const StyledBox = styled(Box)({
  padding: '8px 16px',
  borderRadius: '4px',
  backgroundColor: blue[50],
});

export const LeftColCardTable = styled(CardTable)({
  flex: 1,
  borderRight: 'none',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  '& th': { textAlign: 'right' },
});

export const RightColCardTable = styled(CardTable)({
  flex: 1,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  '& th': { textAlign: 'right' },
});
